import { WALLET_PENDING_PASS_STORAGE_KEY, WALLET_PENDING_SAVE_URL_STORAGE_KEY } from "@/utils/WalletConstants"

export function getPendingPassId(): string | null {
    try {
        return sessionStorage.getItem(WALLET_PENDING_PASS_STORAGE_KEY)
    } catch {
        return null
    }
}

export function getPendingSaveUrl(): string | null {
    try {
        return sessionStorage.getItem(WALLET_PENDING_SAVE_URL_STORAGE_KEY)
    } catch {
        return null
    }
}

export function savePendingPassId(passId: string, saveUrl?: string) {
    try {
        sessionStorage.setItem(WALLET_PENDING_PASS_STORAGE_KEY, passId)
        if (saveUrl) sessionStorage.setItem(WALLET_PENDING_SAVE_URL_STORAGE_KEY, saveUrl)
    } catch {
        return
    }
}

export function clearPendingPassId() {
    try {
        sessionStorage.removeItem(WALLET_PENDING_PASS_STORAGE_KEY)
        sessionStorage.removeItem(WALLET_PENDING_SAVE_URL_STORAGE_KEY)
    } catch {
        return
    }
}
